import icon from "@material-ui/icons/AccountBalanceWallet"
export { default as ReceiptList } from "./receipts/list";
export { default as ReceiptCreate } from "./receipts/create";

export default { icon } ;


